export const TALENT_ROLES = [
  "3d modelling",
  "aaaa",
  "Abogado ",
  "Accountant ",
  "Account Executive",
  "Accounting ",
  "Accounting and Bookkeeping ",
  "Accounting and finance ",
  "Accounts Receivable Specialist",
  "Additive Manufacturing Engineer",
  "Add post",
  "Admin",
  "Admin Assistant",
  "Administerative",
  "Administración asistencia ",
  "Administradora",
  "Administradora de Empresas",
  "AdminSystem",
  "Adobe Experience Consultant",
  "Adobe Experience Manager",
  "Ads Specialist",
  "Advisor Financial Analyst",
  "Agile Coach",
  "Agile delivery lead ",
  "Ai",
  "Ai content editor ",
  "AI Engineer",
  "AI/ML",
  "AI/ML Engineer",
  "AI Platform Engineer Intern",
  "Air conditioning teachnition ",
  "Aircraft engineer ",
  "All degine",
  "All types of works of freelance ",
  "aloha",
  "ambiental",
  "Analista de sistemas ",
  "Android developer ",
  "Android Developer",
  "Android Engineer",
  "Angular Developer ",
  "Any",
  "API Engineer",
  "Applications DBA Oracle",
  "APQP Quality Engineer",
  "Aprendiendo",
  "Architectural/Interior draftsman",
  "Artical writer",
  "Article writer in community ",
  "As400 developer ",
  "asda",
  "Asesor ",
  "Asesoría ",
  "Asistente",
  "asistente administrativo",
  "Asistente de diseños ",
  "Asistente Virtual",
  "assignmen",
  "Assignment",
  "Assistant Campus Manager ",
  "Assistant Professor",
  "Associate consultant ",
  "Associate DevOps Engineer",
  "associate product manager ",
  "Associate software engineer ",
  "as you wish",
  "Atencion al publico",
  "Atencions client ",
  "Auditing Engineer II",
  "Auditing Engineer III",
  "Auditor Interno",
  "AUTO CADD ",
  "Automation Consultant",
  "Automation Quality Assurance Engineer",
  "Automobile engineer",
  "Auxiliar contable",
  "AV/ADAS Scenario Engineer",
  "AWS (Amazon Web services) Developer",
  "AWS Cloud Administrator ",
  "AWS Cloud Engineer",
  "AWS DevOps Engineer",
  "AWS Python/PySpark Developer",
  "Ayudante de mecanica ",
  "Azure ",
  "Azure cloud engineer ",
  "Azure Cloud Support Engineer",
  "Azure Data Engineer",
  "Bachelor's degree in accounting and finance",
  "Backend cordinator",
  "Backend developer",
  "Backend developer ",
  "Backend Developer - Infra Team",
  "Back End Developer intern",
  "Back-End Developer Java",
  "Backend Engineer",
  "Backend Engineer (Golang) - Remote",
  "Backend Engineer (Java) - Remote",
  "Backend Software Engineer",
  "Backend Team Leader",
  "Bangladesh",
  "Bangladesh and Dhaka ",
  "banker",
  "BI Administrator",
  "Big Data Engineer",
  "Bilingual Human Resources Manager",
  "BIM Managing Architect ",
  "Biomedical engineer",
  "Biotechnology ",
  "Blockchain Architect",
  "Blockchain Core Developer - Golang, Ethereum",
  "Blockchain Developer",
  "Blockchain Engineer",
  "Blockchain Engineering Manager",
  "Blockchain Protocol Architect",
  "Blockchain Research Analyst",
  "Blockchain Security Engineer",
  "Blockchain Software Engineer",
  "Blockchain Strategist and Tokenization Project Manager",
  "blogger",
  "Board Member",
  "Bot Developer",
  "Br",
  "Branch Manager",
  "Brand Designer",
  "Brand Manager ",
  "broadcast",
  "broadcast engineer",
  "BSA Trizetto",
  "Bus",
  "Busines",
  "Business",
  "Business ",
  "Business administration ",
  "Business Analyst HRIS",
  "Business Brand",
  "Business Data Analyst",
  "Business Development",
  "Business development manager ",
  "Business in Business",
  "Business Intelligence Analyst",
  "Business Intelligence & Data Analytics Professional",
  "Business lead - Microsoft ",
  "business manager",
  "Business support coordinator ",
  "Business System Analyst",
  "Business Systems Analyst",
  "By and sael",
  "C++",
  "Call Center Supervisor",
  "Canva editor ",
  "Car machanic ",
  "Cars engine machnic ",
  "Category",
  "C++ Developer",
  "CEO",
  "cerrador de ventas",
  "Channel Marketing Manager ",
  "Chef",
  "Chemical Engineer",
  "Chief Marketing Officer",
  "Chief Operations Officer",
  "Chimichangas",
  "CIT",
  "Civil Engineer ",
  "Client Service Officer",
  " Clinical pharmacist ",
  "Clinical research associate ",
  "closer de ventas low ticket y high ticket",
  "Cloud",
  "Cloud Architect",
  "Cloud consultant and Devops ",
  "Cloud DevOps Engineer",
  "Cloud Engineer",
  "Cloud/Infrastructure engineer",
  "Cloud Operations Engineer",
  "Cloud Security",
  "CLOUD SUPPORT ENGINEER",
  "Cloud Technical Support",
  "coding",
  "Colour",
  "Communications Specialist",
  "Community Manager",
  "Community manager/engagements ",
  "Community/Social media manager ",
  "Company for ",
  "Compro y vendo ",
  "Computer engineer ",
  "Computer Operator",
  "Computer Sciences ",
  "Computer work ",
  "Concept Artist ",
  "Contador ",
  "Contador Público Colegiado",
  "Content coordinator",
  "Content Marketing, Content writing ",
  "Content writer ",
  "Content Writer",
  "Content Writer ",
  "content writer ,posting , ",
  "Cook job pak",
  "Copy and paste",
  "Copyright ",
  "copywriter",
  "Copywriting",
  "Core Blockchain Team Lead",
  "Core Contributor (Data Engineer)",
  "Core Developer (Python)",
  "Corporate IT Associate",
  "Cost Estimator ",
  "Creater",
  "Creative Vice Chair IEEE SOU SB ",
  "Creativity ",
  "CRM",
  "Crypto currency smart contract work ",
  "Crypto Quant Developer",
  "Cuidadora tercera edad ",
  "Customer engagement Sr Technical Program manager",
  "Customer relation management ",
  "Customer service ",
  "Customer service agent ",
  "Customer Service Associate",
  "Customer Service Rep/ Dispatcher",
  "Customer service representative",
  "Customer Success",
  "Customer Success Manager",
  "Customer support manager",
  "Customer Support Specialist",
  "Cybersecurity Analyst",
  "Cybersecurity Engineer",
  "Data Analyst",
  "Data Analyst Manager",
  "Data analysts",
  "Data analyt",
  "Data & Analytics Engineer, Senior Staff",
  "Data Architect",
  "Database Administrator",
  "Database architect ",
  "Database Engineer",
  "Database Support",
  "Data collection ",
  "Data Engineer",
  "Data Engineering Intern (Remote)",
  "Data Engineering, Team Lead, Toronto",
  "data entry",
  "Data Entry ",
  "Data entry clerk",
  "Data Governance",
  "Data Integration Lead",
  "Data Platform Engineer",
  "Data product manager ",
  "Data Quality Analyst",
  "Data science",
  "Data Science (Blockchain) Associate",
  "Data Scientist",
  "Data Scientist Intern",
  "Data SME Architect",
  "Data Specialist",
  "DeFi Protocol Engineer - Ethereum, Python",
  "Delete Account",
  "Demand Generation Lead",
  "Deployment Engineer",
  "Deputy Manager (Market analyst)",
  "Desarrollador en Visual Basic 6.0",
  "Desarrollador JavaScript ",
  "Desarrollador web Front End",
  "Designed your way",
  "Design engineer ",
  "Designer",
  "Designer ",
  "Designing",
  "Design Team Lead",
  "Developer Advocate",
  "Developer Oracle",
  "Developer Relations",
  "Developer Relations Engineer",
  "Developer Relations Lead",
  "Development officer",
  "Devops",
  "DevOps Engineer",
  "Devops Team Lead",
  "DevRel",
  "DevSecOps Engineer",
  "dfxcgjhgfd",
  "Digital Accessibility",
  "Digital designer",
  "Digital Marketer",
  "Digital marketing ",
  "Digital Marketing Lead",
  "Digital Marketing & Project Management Specialist",
  "Director of Engineering",
  "Director of Engineering, Product",
  "Director of IT",
  "Director of Sales",
  "Director Sales Operations",
  "Director Software Development",
  "Director, Solutions Architects",
  "Director, Solutions Engineering",
  "Diseñador de redes de telecomunicación ",
  "Diseñador gráfico ",
  "Diseñador UX UI",
  "Diseño grafico ",
  "diseño industrial",
  "Diseños",
  "Diseños en línea ",
  "Diseño y desarrollo de proyectos para Negocios ",
  "Disponible a cualquier trabajo ",
  "Dispuesta a cualquier área de trabajo ",
  "Django developer",
  "doctor",
  "Doe Net Lead",
  "Do fartest data entry ",
  "Do Fastest Data Entry ",
  "Dot Net ",
  "Drive ",
  "Driving",
  "Dsign",
  "Dynamics 365 BC- ERP Consultant",
  "Dynamics 365 BC/Nav - ERP Consultant",
  "Dynamics 365 Consultant",
  "Dynamics 365 Manager",
  "early adopter",
  "Earning ",
  "E-commerce BA/PM",
  "Ecommerce specialist ",
  "Economist",
  "Editing ",
  "Editing,Digital creator,community and marketing ",
  "Editing,Social media moderators",
  "Editor.",
  "Ejecutiva de Ventas",
  "Electrical",
  "Electrical-Electronics Engineer",
  "Electrical engineer",
  "Electrical Engineering Lead",
  "Electrician ",
  "electronic",
  "Electronic assembly ",
  "Electronic Engineer",
  "electrónico",
  "Email ",
  "Email marketing ",
  "Email Support",
  "Embedded Cybersecurity Software Engineer",
  "Embedded Developer",
  "Employee ",
  "Engagement Manager",
  "Engineering  assistant ",
  "Engineering Director, Travel",
  "Engineering Lead",
  "Engineering Manager, Application Development",
  "Engineering Manager - Automation Platform",
  "Engineering Manager, Backend",
  "Engineering Manager, Compute",
  "Engineering Manager - Core Ledger Platform",
  " Engineering Manager, Developer Experience",
  "Engineering Manager, Feature Engineering",
  "Engineering Manager (Full Stack)",
  "Engineering Talent Pool",
  "Engineer Manager (DevOps)",
  "Enterprise Architect",
  "Enterprise Outbound Sales Development Representative (SDR)",
  "Enterprise Product Manager",
  "Entrepreneur ",
  "ERP",
  "Escalation agent",
  "Estudiante de arquitectura ",
  "Estudiante de medicina ",
  "ETL Developer (Extraction, Transformation, Loading)",
  "Experience in ms Word excel and typing jobs",
  "Expert Software Engineer, Real-Time Systems (RTS)",
  "External Auditor ",
  "Fabric Pattern and CAD",
  "Fashion desining",
  "Finance ",
  "Finance manager",
  "Financial Analyst",
  "Firmware Engineer",
  "Fist work",
  "Flutter Developer",
  "Food delivery",
  "Food technologist ",
  "footwear designer",
  "Fotógrafo ",
  "Foundations Engineering Manager",
  "Founder",
  "Founder's Office",
  "Founding Developer Relations Engineer",
  "Freelancer ",
  "Freelance Recruiter",
  "Freelance writing job ",
  "Fresher",
  "Fronted ",
  "Frontend",
  "Front end developer ",
  "Frontend developer",
  "Frontend developer ",
  "Front End Developer - Vuejs / Nuxt",
  "Front End Development Intern",
  "Frontend Engineer",
  "Frontend Engineering",
  "Front-End Software Developer",
  "Frontend Software Engineer (Slovenia)",
  "Front End Tech Lead",
  "Front office executive ",
  "fuck—this—website",
  "fukcthiswebsite",
  "Full Stack Blockchain Engineer",
  "Full stack developer ",
  "Fullstack Engineer",
  "Full Stack Java Developer",
  "Full-Stack Java Developer",
  "Fullstack Javascript Developer",
  "Full Stack MERN",
  "Fullstack Python",
  "Full Stack Software Developer",
  "Full-Stack Software Engineer",
  "Funkaat",
  "Game Developer",
  "Generative Ai",
  "Geospatial Engineer",
  "Gerente de proyectos ",
  "Global Success Manager",
  "Global Technical Recruiter",
  "Golden Gate",
  "Graduate",
  "Graduate DeFi Algorithmic Trader",
  "Grafit",
  "Graphic ",
  "Graphic design",
  "graphic designer",
  "Graphic designer",
  "Graphic designer ",
  "Graphic Designer",
  "Graphic design & poster making ",
  "Graphicsdesign",
  "Graphics designer ",
  "Graphics Designer",
  "graphics photo editor",
  "Graphics Software developer ",
  "Ground Segment RF Engineer",
  "Group Product Manager",
  "Growth Engineer",
  "Guest relations supervisor ",
  "Handling ",
  "Hardware Engineer",
  "Hardwarkar ",
  "Head of Business Development",
  "Head of Engineering",
  "Head of Finance",
  "Head Of Growth",
  "Head of Protocol Engineering",
  "Head of Software Engineering",
  "Health",
  "Health and safety",
  "Helper ",
  "hi",
  "HR",
  "HR Business Partner",
  "Hr delivery specialist ",
  "HR executive ",
  "HR & Talent Acquisition Partner",
  "Human Resources",
  "Human Resources Business Partner",
  "IAM Architect",
  "IBMi developer",
  "IBM MAINFRAME COBOL DEVELOPER",
  "ICT Consulting",
  "Ict tech",
  "Implementation Engineer",
  "Inbound Sales Development Representative (SDR)",
  "Incharge ",
  "Indistrial",
  "industrial",
  "Industrial",
  "Industrial Engineer",
  "Industrial UI/UX Designer",
  "IndustryGraphic design",
  "Influencer",
  "Information Security Manager",
  "information technology engineer",
  "Infraestructure Analyst",
  "Infrastructure Engineer",
  "ingenieria ambiental",
  "Ingeniería comercial ",
  "Ingeniero back-end",
  "Ingeniero black-ken ",
  "Ingeniero de iA",
  "Ingeniero de Sistemas y Computo",
  "Ingeniero Electrónico ",
  "Ingeniero Front End",
  "Inserción de local ",
  "INSIDE SALES ENGINEER",
  "Institucional",
  "Instrumentación y Control ",
  "Intake Specialist",
  "Integrated Eligibility System Java Developer",
  "Intelligent ",
  "Interaction design",
  "Interior designer ",
  "Intermediate Full-stack Engineer",
  "Intermediate GoLang Engineer",
  "Intermediate Rust Engineer ",
  "Internationalist",
  "Interpreter",
  "Invatation card",
  "iOS Engineer",
  "Isa agent",
  "it",
  "IT Administrator",
  "IT Audit",
  "IT Deskside Support",
  "IT Infrastructure Architect",
  "IT Manager",
  "IT Staffing & Recruiting",
  "IT Staffing & Recrutiing",
  "Jaggery quality and test ",
  "james agribusiness",
  "JAVA",
  "java developer ",
  "JAVA DSA ",
  "Java Fullstack Developer",
  "java ful-stack",
  "JavaScript",
  "JavaScript developer",
  "Java Software Engineer",
  "Job",
  "Job title/role",
  "Journalist",
  "Junior Cloud Engineer",
  "Junior Data Engineer",
  "Junior graphic designer ",
  "Junior Project Manager",
  "Junior Python/Django Developer",
  "Junior Web Development",
  "Karyawan",
  "Key Account Manager | Business Developer | Product Manager",
  "Kubernetes",
  "Laravel Developer",
  "Lawyer",
  "Lead Accounting Software Engineer",
  "Lead Animator",
  "Lead Backend Engineer - Analytics",
  "Lead consultant",
  "Lead Data Engineer",
  "Lead Developer",
  "Lead Engineer, Foundation Models",
  "Leadership and Management ",
  "Lead Field Service Engineer - Robot Fleet Operations",
  "Lead Financial Crimes Investigator",
  "Lead Frontend Engineer, Web Presence",
  "Lead QA",
  "Lead React Native Engineer",
  "Lead SDET Engineer",
  "Lead Software Engineer",
  "Lead UI/UX Designer",
  "Lead Unity Engineer, Tools Development",
  "Licda. Contaduria ",
  "Linux",
  "Linux administrators ",
  "Logística y Transporte",
  "Logo and graphic designer ",
  "Logo and poster Designer ",
  "Logo And Visiting Card maker",
  "Logo design",
  "Lo que sea",
  "M365 Admin",
  "Machine Learning Developer",
  "Machine Learning Engineer",
  "Machine Learning Engineer - Infrastructure and Automation",
  "Machine Learning Support Engineer",
  "macOS | TVOS | watchOS | Android | Backend",
  "Maestra de cocina ",
  "Maestro mayor de obras ",
  "Magento BA",
  "Magento developer",
  "Mainframe AS/400 Developer",
  "Mainframe Developer",
  "Main social media kam bhi karta hun main writing bhi karta hun",
  "Maintenance Engineer",
  "Maintenance Technician ",
  "Mai writing job b krrte hu aur copy and paste k kam krrte hu",
  "Major Incident manager",
  "Makeup artist",
  "Manager",
  "Manager, Avionics Test Engineering",
  "Manejo de redes telecomunicaciones ",
  "Mangar ",
  "Manhattan WMS",
  "Manual QA",
  "Manual Tester",
  "Manufacturing Engineer, ECLSS",
  "Marketer",
  "Marketing",
  "Marketing ",
  "Marketing and international business",
  "Marketing Consultant",
  "Marketing digital ",
  "Marketing Digital",
  "Marketing executive",
  "Marketing Lead",
  "Marketing manager",
  "Marketing Manager in the crypto project",
  "Marketing Operations",
  "Market leader ",
  "Market Research Lead",
  "Mark Magic",
  "Material Management Specialist",
  "MDM Stibo QA Lead",
  "MEAN Stack",
  "Mecánica ",
  "Mecánico ",
  "Mecánico de mantenimiento industrial ",
  "Mechanic ",
  "Mechanical Design Engineer",
  "Mechanical Engineering Lead/Manager",
  "Mechatronics Engineer",
  "Medical ",
  "Medical biller",
  "Medical billing denial management ",
  "Medical Gas TECHNICIAN ",
  "Medicen",
  "MERN",
  "Mern Stack Engineer",
  "MES EBR Pharmasuite Consultant",
  "Microsoft Dynamics 365 Developer",
  "Microsoft Learn Student Ambassador",
  "Mid level",
  "Mid-Senior Backend Engineer",
  "MIT Computer Science Recent Grad",
  "ML Engineer",
  "MLOps Engineer",
  "Mobile",
  "Mobile Application Developer",
  "Mobile/Application Engineer",
  "Mobile Engineer",
  "Mocop design",
  "Moderator",
  "Motion Design",
  "Ms Excel",
  "NDT",
  "Negocios en compras y ventas ",
  ".Net Developer",
  "NetSuite Developer",
  "Network and Systems Engineer",
  "Network and Telecommunications Engineer ",
  "Networking Embedded Software Engineer",
  "NFT Strategist",
  "nhan vien",
  "Nhân viên",
  "Nodejs",
  "Nodejs Developer ",
  "Nogociar ",
  "Non of metter roles",
  "No rules ",
  "Nuclear Engineer",
  "Nurse",
  "Nutritionist ",
  "ODI Developer",
  "Odontólogo ",
  "Odoo Business Analyst",
  "Odoo ERP / CRM developer",
  "Office Assistant ",
  "Office Manager",
  "Officer",
  "Online earn business",
  "Online earnings ",
  "Online job",
  "Online marketing ",
  "Online sale",
  "Online Worker",
  "Only for work",
  "Operational Director",
  "Operations ",
  "Oracle Application Framework",
  "Oracle Cloud Architect",
  "Oracle Cloud Project Manager",
  "Oracle Cloud Technical",
  "Oracle EBS Architect",
  "Oracle EBS Developer",
  "Oracle EBS Functional Finance",
  "Oracle EBS Technical Finance",
  "Oracle EBS Technical SCM Lead",
  "Oracle EBS Techno-Functional Lead SCM",
  "Oracle EPM",
  "Oracle ERP Consultant",
  "Oracle Financial Cloud Analyst",
  "Oracle Financial Functional",
  "Oracle HCM Consultant",
  "Oracle HCM Functional",
  "Oracle Infrastructure Architect",
  "Oracle Integration Consultant",
  "Oracle OSM Developer",
  "Oracle TRCS Consultant",
  "Order Manager Analyst",
  "Outlet Executive",
  "Paid Media",
  "Painter ",
  "Pantrista",
  "Parcel delivery ",
  "PAS | X MES MBR Designer",
  "Patron",
  "Pay stub",
  "PDF convention",
  "Pdf to word",
  "Pdg",
  "Pega Developer",
  "Pekerja",
  "Performance Engineer",
  "Performance Software Engineer",
  "Periodista ",
  "Pharmacist ",
  "Pharmacy ",
  "Photographer ",
  "Photos design ",
  "Php developer ",
  "PHP Developer",
  "PHP Full-Stack Developer",
  "Physiotherapist ",
  "Planning and Analysis",
  "Planning and development ",
  "Planning Engineer",
  "Plant, Factory and Operation Director",
  "Platform Engineer  ",
  "Platform Engineering Intern",
  "Platform Engineer, Staff",
  "Platform Tech Lead Manager",
  "plsql developer",
  "PL/SQL Developer",
  "PL/SQL Lead Developer",
  "Power BI",
  "Power BI Architect",
  "Power Bi Developer ",
  "Power BI Developer",
  "Power BI Tech Lead",
  "Powerpoint Specialist | Estimator",
  "Prequalification Specialist",
  "Presales Engineer",
  "Principal Backend Engineer",
  "Principal Consultant",
  "Principal Engineer",
  "Principal Full Stack (Web, Mobile and ML) Engineer",
  "Principal Security Engineer",
  "Principal Software Engineer",
  "Principal Software Engineer, Trading Systems",
  "Probador",
  "Probadora de productos ",
  "Product Analyst",
  "Product&design",
  "Product Designer",
  "Product Design Intern",
  "Product development and product management ",
  "Product Growth",
  "Production ",
  "Production Engineer ",
  "Product Lead",
  "Product Management Specialist",
  "Product manager",
  "Product Manager",
  "Product Manager- Internal Tools",
  "Product Manager IT",
  "Product Manager (Multi-Chain)",
  "Product Marketer",
  "Product Marketing Manager",
  "Product owner ",
  "Product saler",
  "Product sales and business ",
  "Product Security Engineer",
  "Product selling ",
  "Product service ",
  "Products selling only online work conversation ",
  "Product Tester",
  "Profesora ",
  "Professional seller ",
  "Programador full stack",
  "Program Manager",
  "Programmer Analyst",
  "Programmer/Data Analyst",
  "Project Manager",
  "Promocionar productos ",
  "Promocion Creativo Digital -Mercadeo Publicidad",
  "Promopt engreeing",
  "proofreading",
  "Proprietor ",
  "Protocol Engineer",
  "Protocol Lead",
  "Protocol Security Engineer",
  "Publicidad digital",
  "Public Management and Consultancy ",
  "public relations",
  "Purchaser",
  "pyhton developer",
  "python",
  "python developer",
  "QA Automation Engineer",
  "QA Engineer",
  "QA Manual Lead",
  "QA SDET",
  "QA-SDET",
  "QA Test Automation Engineer",
  "Quadient Inspire Developer",
  "Quality Assurance",
  "Quality Assurance Engineer",
  "Quality Assurance Engineer – HW/SW Integration",
  "Quality Assurance Engineer (Mid)",
  "Quality Engineer",
  "Quality Engineering Analyst",
  "Quality Manager",
  "Quantitative Researcher",
  "Rangers ",
  "React",
  "React Developer",
  "React Gatsby Lead",
  "React Native",
  "React Native Developer",
  "Recruiter",
  "Recruiter Consultant",
  "Redacción ",
  "Redes sociales",
  "Reine Empire",
  "Reine services ",
  "Research and Development ",
  "Research Engineer",
  "Research Engineer, Motion Planning",
  "Research Manager",
  "Restaurant ",
  "Resturant  ",
  "Retail supervision ",
  "Revenue development Executive ",
  "RF Test Engineer",
  "Risk Analyst",
  "Risk management ",
  "RPA/Automation SME",
  "RPA Developer",
  "RPG/AS400 Developer",
  "Ruby On Rails",
  "Rust Application engineer",
  "Sailpoint",
  "Sale",
  "Sale man",
  "Sale man inbrand ",
  "Sales ",
  "Salesforce Administration and Development",
  "Salesforce Cloud Architect",
  "Salesforce Developer",
  "Salesforce Integration Developer",
  "Sales Manager ",
  "SALES MANAGER",
  "Sales Representative",
  "SAP Architect",
  "SAP associate",
  "SAP Business One Consultant",
  "SAP EAPS Consultant",
  "SAP FICO CONSULTANT",
  "SAP HR Consultant",
  "SAP MM Consultant",
  "Scrum Master",
  "SDET - Python",
  "Secretaria",
  "Security Architect",
  "Security Auditor",
  "Security Engineer Intern",
  "Security officer ",
  "Security Software Engineer Lead",
  "Sel",
  "Seller",
  "Senior Account Executive",
  "Senior Accounting Software Engineer",
  "Senior Accounting Specialist",
  "Senior Account Manager",
  "Senior AI Engineer",
  "Senior AI Researcher",
  "Senior Android Engineer",
  "Senior Application Security Engineer",
  "Senior Applied Cryptographer",
  "Senior Autonomy Engineer ",
  "Senior Autonomy Engineer - LIDAR",
  "Senior Avionics Test Engineer",
  "Senior Backend Engineer",
  "Senior Backend Engineer - AI",
  "Senior Back-End Engineer (Javascript, Python)",
  "Senior Backend Engineer, Trading Desk",
  "Senior Backend Software Engineer",
  "Senior Backend Software Engineer, Data Pipelines",
  "Senior Blockchain Engineer",
  "Senior BSA Compliance Manager",
  "Senior Business Development Manager (US)",
  "Senior C++ Developer",
  "Senior Cloud/DevSecOps Security Engineer",
  "Senior Cloud Engineer",
  "Senior Cloud-Native Golang Engineer",
  "Senior Compliance Engineer",
  "Senior Cryptographic Engineer",
  "Senior Cryptography Engineer",
  "Senior Data Analyst",
  "Senior Data Engineer",
  "Senior Data Operations Engineer",
  "Senior Designer",
  "Senior Developer",
  "Senior DevOps Engineer, Blockchain Services",
  "Senior DevOps Engineer - Engineering Operations",
  "Senior DevOps/SRE Engineer",
  "Senior Ecosystem Solution (Full-Stack) Engineer",
  "Senior Electrical Engineer",
  "Senior Embedded Software Engineer",
  "Senior Engineering Manager - Sanity Studio",
  "Senior Engineering Manager - User Experiences",
  "Senior Front-End Developer",
  "Senior Frontend Engineer",
  "Senior Front End Engineer",
  "Senior Front-End Engineer, Platform/Design Systems",
  "Senior Frontend Engineer (React)",
  "Senior Frontend Engineer (React, Next.JS, Typescript)",
  "Senior Frontend Engineer (React, React Native)",
  "Senior Frontend Software Engineer",
  "Senior Full Stack Developer",
  "Senior Full Stack Developer - Buyer Team",
  "Senior Full Stack Engineer",
  "Senior Full-Stack Engineer",
  "Senior FullStack Engineer - AI",
  "Senior Full Stack Engineer (Integrations)",
  "Senior Fullstack Python developer",
  "Senior Full Stack Software Engineer",
  "Senior Golang Engineer",
  "Senior infrastructure Engineer",
  "Senior Infrastructure Security Engineer",
  "Senior iOS Consultant",
  "Senior iOS Engineer",
  "Senior IT Business Systems Analyst",
  "Senior Java Developer",
  "Senior L2 Infra Engineer (Rust)",
  "Senior/Lead Gameplay Designer",
  "Senior Level Designer",
  "Senior Machine Learning Engineer",
  "Senior Machine Learning Systems Engineer",
  "Senior ML Engineer",
  "Senior Mobile Software Engineer",
  "Senior Network Engineer ",
  "Senior Nuclear Engineer",
  "Senior PHP & Vue.Js Full-Stack Developer",
  "Senior Platform Engineer",
  "Senior Platform Engineer, Developer Experience",
  "Senior Platform Engineer (GCP, K8s, Terraform)",
  "Senior Platform Software Engineer",
  "Senior/Principal Software Engineer - Client",
  "Senior Product Designer",
  "Senior Product Manager - Payments",
  "Senior Product Marketing Manager, Identity Protection",
  "Senior project engineer",
  "Senior Python Software Engineer - Web3, DeFi",
  "Senior QA Test Analyst",
  "Senior React Native Engineer",
  "Senior RF & DSP Engineer",
  "Senior Rust Engineer",
  "Senior Sales Executive",
  "Senior Salesforce Developer",
  "Senior Security Engineer",
  "Senior Servicenow Developer",
  "Senior Site Reliability Engineer",
  "Senior Site Reliability Engineer - Azure",
  "Senior Site Reliability Engineer - Node Operations",
  "Senior Smart Contract Engineer (Solidity)",
  "Senior Software Developer",
  "Senior Software Engineer",
  "Senior Software Engineer (Backend)",
  "Senior Software Engineer, Backend",
  "Senior Software Engineer (Backend) - Content Lake DX",
  "Senior Software Engineer - CloudOps",
  "Senior Software Engineer - Cognitive Platform",
  "Senior Software Engineer - Cryptography",
  "Senior Software Engineer - Ecosystem Integrations",
  "Senior Software Engineer, Encryption Services ",
  "Senior Software Engineer, Financial Markets",
  "Senior Software Engineer, Frontend",
  "Senior Software Engineer (Full Stack)",
  "Senior Software Engineer Full Stack",
  "Senior Software Engineer, Full Stack",
  "Senior Software Engineer, Golang",
  "Senior Software Engineer, Ground Software",
  "Senior Software Engineer, High Performance Computing",
  "Senior Software Engineer II",
  "Senior Software Engineer, Infrastructure",
  "Senior Software Engineer, Low-Latency Systems",
  "Senior Software Engineer, Machine Learning",
  "Senior Software Engineer – Realtime Communications",
  "Senior Software Engineer - Sanity Studio",
  "Senior Software Engineer, Security",
  "Senior Software Engineer, Security (Full Stack)",
  "Senior Software Engineer, Server/Backend",
  "Senior Software Engineer (TS//SCI)",
  "Senior Solidity Engineer",
  "Senior SRE Engineer(Ethereum)",
  "Senior/Staff Backend Software Engineer",
  "Senior SW Engineer",
  "Senior Systems Engineer",
  "Senior Talent Acquisition Specialist",
  "Senior UX Researcher",
  "Senior UX Writer",
  "Senior VFX Artist",
  "seo",
  "SEO expert ",
  "SEO specialist ",
  "SEO Specialist",
  "Ser mi pro",
  "Service Designer",
  "Service management ",
  "ServiceNow Architect",
  "ServiceNow ITSM Consultant",
  "Servicios y atencion a usuarios ",
  "Setters ",
  "Settlement Specialist",
  "Siebel Administrator",
  "Sistemas ",
  "Site Autonomy Engineer",
  "Sitecore Engineer",
  "Site Reliability Engineer",
  "Site Reliability Engineering (SRE) Manager",
  "Smart Contract Developer",
  "Smart Contract Engineer - Ethereum, Soldity",
  "Snowflake developer ",
  "SOC analyst",
  "Social media manger",
  "social media marketer",
  "Social media marketing, Social media management ",
  "Social work",
  "software ",
  "Software and Hardware",
  "Software Architect",
  "Software Asset Management",
  "Software Customer Success",
  "Software developer ",
  "Software Developer - Front-end",
  "Software Development Engineer",
  "Software Development Engineer - 3 iOS",
  "Software Development Engineer in Test",
  "Software Development Engineer in Test (SDET)",
  "Software engineer ",
  "Software Engineer",
  "Software Engineer, AI",
  "Software Engineer, Application Security",
  "Software Engineer - Backend",
  "Software Engineer, Backend",
  "Software Engineer - Build",
  "Software Engineer, Compute",
  "Soft ware engineer & content creator ",
  "Software Engineer, Core Data Ingestion",
  "Software Engineer, Data Infrastructure",
  "Software Engineer (Egypt)",
  "Software Engineer Engineer (Full Stack)",
  "Software Engineer, Frontend",
  "Software Engineer (Frontend) (m/f/d)",
  "Software Engineer, Front-end (React)",
  "Software Engineer II - Backend",
  "Software Engineer II – Front-end",
  "Software Engineer II - Full Stack",
  "Software Engineer III - Backend",
  "Software Engineer III – Front-end",
  "Software Engineering",
  "Software Engineer Intern",
  "Software Engineer in Test SDET",
  "Software Engineer, Java",
  "Software Engineer, Machine Learning",
  "Software Engineer, Mobile - Strongline",
  "Software Engineer, Multicloud",
  "Software Engineer (Noir Generalist)",
  "Software Engineer (Pakistan)",
  "Software Engineer, Platform",
  "Software Engineer (Product - Full Stack)",
  "Software Engineer, Realtime Execution",
  "Software Engineer, Swift",
  "Software Engineer, Tokyo",
  "Software Frontend Engineer (React.JS, Next.JS, Typescript)",
  "Software Partner Enablement",
  "Software Pre-Sales Consultant",
  "Software QA Tester",
  "Software Simulation Engineer",
  "Software Technical Writer",
  "Software Testing and Quality Assurance",
  "Software Test Lead",
  "Solidity Developer",
  "Solution Architect",
  "Solutions Architect",
  "Something ",
  "Soporte ti",
  "Soporte y atención al cliente ",
  "Sourcing Manager ",
  "SpringBoot",
  "SQA Engineer ",
  "SQL architect ",
  "SQL DBA",
  "sql developer",
  "SQL Developer",
  "Sr. Account Executive",
  "Sr. Data Analyst",
  "Sr. Data Engineer",
  "Sr. Design Manager",
  "Sr. EDI Consultant",
  "Sr. Full Stack Developer (Nodejs+TS)",
  "Sr. Fullstack Engineer",
  "Sr Full Stack Engineer, Frontend",
  "Sr Full Stack Engineer, Frontend (Canada)",
  "Sr. Full Stack Java Developer",
  "Sr Fullstack .Net Engineer",
  "Sr. Human Resources Manager",
  "Sr. Java Full Stack Developer",
  "Sr. LLM Engineer",
  "SR. manager",
  "Sr. PHP Laravel & Vue.js Develper",
  "Sr. Product Manager: Integrations",
  "Sr. Product Manager, Virtual Office",
  "Sr. Site Reliability Engineer (SRE)",
  "Sr Software Engineer",
  "Ssr laravel",
  "STAF ADMINISTRASI",
  "Staff Backend Engineer - Savings",
  "Staff Backend Engineer, Trading Desk",
  "Staff Data Scientist - Performance",
  "Staff DevOps Engineer",
  "Staff Electrical Engineer",
  "Staff Engineer",
  "Staff Fullstack Engineer",
  "Staff Full Stack Engineer",
  "Staff Full Stack Engineer (Security)",
  "Staff Machine Learning Engineer - Defense",
  "Staff Machine Learning Systems Engineer",
  "Staff Move Engineer",
  "Staff / Principal Front End Engineer",
  "Staff Product Platform Engineer",
  "Staff Software Engineer",
  "Staff Software Engineer, 3D Visualization",
  "Staff Software Engineer (Backend)",
  "Staff Software Engineer, Backend",
  "Staff Software Engineer, C++",
  "Staff Software Engineer - Content Lake DX (Scale)",
  "Staff Software Engineer, Core Ledger Platform",
  "Staff Software Engineer, Data Incrementalization",
  "Staff Software Engineer, Frontend - Apps",
  "Staff Software Engineer (Full Stack)",
  "Staff Software Engineer - Infrastructure",
  "Staff Software Engineer, Infrastructure",
  "Staff Software Engineer, iOS, Haven",
  "Staff Software Engineer, Machine Learning",
  "Staff Software Engineer - Platform Engineering",
  "Staff Software Engineer - Product",
  "Staff Software Engineer, Security (Full Stack)",
  "Staff Solutions Engineer - East Region",
  "Stibo Developer",
  "storage and backup administrator",
  "Store keeper ",
  "Structural Design Engineer",
  "Student",
  "Sub-engineer",
  "Supervisor ",
  "Supplier Quality Engineer",
  "Supply chain executive ",
  "Supply Chain Planning Management",
  "Support Engineer",
  "Support Staff",
  "Survey ",
  "Sustaining Engineer ",
  "System administrator / IT Specialist",
  "System Analyst",
  "System Architect",
  "Systems Administrator",
  "Systems Analyst & Developer Sr (IBM-i,  iSeries,  AS400)",
  "Tableau Administrator",
  "Tableau Visualization Designer",
  "Talent Acquisition",
  "Tax Consultant",
  "Teacher ",
  "Team Lead, Machine Learning Engineer",
  "Tech Lead, Data & ML Platform",
  "Technical Architect",
  "Technical Lead",
  "Technical Lead - Compliance Team",
  "Technical Lead - iOS",
  "Technical Lead - QA SDET",
  "Technical Lead - SDK Development",
  "Technical Lead - Trust Team",
  "Technical Lead - UI",
  "Technical Product Manager",
  "Technical Project Manager",
  "Technical Recruiter",
  "Technical Solutions Analyst",
  "Technical Specialist",
  "Technical support",
  "Technical Support Engineer",
  "Technology-Enabled Maritime Training Designer",
  "Técnico superior universitario",
  "Telecommunications ",
  "Tem HeAd ",
  "TestAcc",
  "TestJob",
  "Test Lead",
  "Thesis",
  "This is will job",
  "Thread",
  "Timeing",
  "Tokenization Project Manager",
  "trade",
  "trader",
  "Trading ",
  "Traductor/Editor/Comunicación ",
  "Trainer ",
  "Tranlator",
  "Translator",
  "Translator ",
  "Trasnformation Lead",
  "tuper",
  "Tutor",
  "Typing",
  "Typing jops",
  "Typing remorte ",
  "UI Designer",
  "UI Developer",
  "UI/UX designer ",
  "UIUX Designer",
  "UIUX Designer ",
  "UI UX & Multimedia  Designer ",
  "Umar",
  "UX Designer",
  "UX Researcher",
  "UX UI",
  "UX / UI Designer",
  "UX UI Designer",
  "UX writer",
  "Vauvwuw wow w8w ",
  "Vendedor ",
  "Vendedora",
  "Vendedora principal",
  "Ventas ",
  "Ventas al publico",
  "Vice President, Investment Operations",
  "Video adit",
  "Video editor ",
  "Video Engineer",
  "Virtual Assistant ",
  "Virtual Reality (VR) Developer",
  "VMware Engineer",
  "VP Engineering",
  "Vuejs",
  "Vuejs Develoer",
  "Warehouse",
  "WCS/HCL Developer",
  "web3",
  "Web3 Builder ",
  "Web3 Developer",
  "Web3 Frontend Engineer",
  "Web3 Operation Lead",
  "Web3 Operations Specialist",
  "Web3 Student Advocate",
  "Web Analyst",
  "web designer",
  "Web designer",
  "web developer",
  "Web developer ",
  "Web developing",
  "Web development. websites.web developer ",
  "Web Graphics Engineer Intern",
  "Website and social media marketing platforms ",
  "Website app",
  "Website designer ",
  "Website designing ",
  "Website Developer",
  "Website Developer ",
  "Wordpress Designer",
  "WordPress developer ",
  "Workday Analyst",
  "Working ",
  "Work in home",
  "Write ",
  "Writer ",
  "Writing ",
  "Writing job freelance ",
  "Writing job freelancer ",
  "yes"
];
